var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgClean(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.8186 15.8478H15.3186V14.3478H19.8186V15.8478Z",
    fill: "#5B78FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.8186 21.8478H18.3186V20.3478H22.8186V21.8478Z",
    fill: "#5B78FF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21.3186 18.8478H16.8186V17.3478H21.3186V18.8478Z",
    fill: "#5B78FF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13.0709 15.8478C13.0656 15.2149 12.8968 14.5942 12.5809 14.0458C12.265 13.4975 11.8127 13.0401 11.2679 12.718L16.8186 3.09778L15.5211 2.34778L9.8384 12.1923C9.14097 12.0365 8.41561 12.058 7.72866 12.2549C7.04172 12.4519 6.41511 12.8179 5.90615 13.3195C3.09815 16.0278 3.31565 22.3593 3.32615 22.6278C3.3339 22.8214 3.41633 23.0046 3.55615 23.1388C3.69597 23.273 3.88233 23.3479 4.07615 23.3478H15.3194C15.4768 23.3478 15.6302 23.2983 15.7579 23.2062C15.8856 23.1142 15.9811 22.9843 16.0309 22.8349C16.0807 22.6856 16.0822 22.5244 16.0353 22.3742C15.9883 22.2239 15.8953 22.0922 15.7694 21.9978C13.1144 20.0058 13.0709 15.8883 13.0709 15.8478ZM9.26615 13.5955C9.86643 13.6021 10.4411 13.8399 10.8705 14.2594C11.2999 14.6789 11.551 15.2478 11.5716 15.8478C11.5716 15.8763 11.5731 16.0038 11.5844 16.1995L7.1594 14.2315C7.45088 13.9912 7.78723 13.8112 8.14891 13.702C8.51058 13.5928 8.89036 13.5566 9.26615 13.5955ZM11.9061 21.8478C11.3067 21.2374 10.9245 20.4468 10.8186 19.5978H9.31865C9.37236 20.396 9.62169 21.1687 10.0446 21.8478H8.3774C8.06896 20.8744 7.8813 19.8669 7.81865 18.8478H6.31865C6.36701 19.8638 6.53441 20.8707 6.8174 21.8478H4.81865C4.8419 20.4708 5.03615 17.4288 6.1709 15.433L11.8206 17.9455C12.0921 19.355 12.6708 20.6874 13.5156 21.8478H11.9061Z",
    fill: "#5B78FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClean);
export default __webpack_public_path__ + "static/media/Clean.413d03fb.svg";
export { ForwardRef as ReactComponent };